/**
 * Małe symbole do wstawiania obok liczb (korona bossa, czaszka wrogów, serce, moc…), rysowane wektorowo,
 * żeby zastąpić krótkie napisy. Kolor bierze z `currentColor`, rozmiar z CSS (.glyph).
 */
const PATHS: Record<string, string> = {
  crown: 'M3 18h18l1.5-11-5.5 4.5L12 4 7 11.5 1.5 7z M4 20h16v2H4z',
  skull: 'M12 2C7 2 3.5 5.6 3.5 10.2c0 2.7 1.3 4.7 3 5.9V19c0 .8.7 1.5 1.5 1.5h1.2v-2.2h1.6v2.2h2.4v-2.2h1.6v2.2H16c.8 0 1.5-.7 1.5-1.5v-2.9c1.7-1.2 3-3.2 3-5.9C20.5 5.6 17 2 12 2zM8.6 13.6a2 2 0 110-4 2 2 0 010 4zm6.8 0a2 2 0 110-4 2 2 0 010 4z',
  heart: 'M12 21s-8.5-5.3-8.5-11.2C3.5 6.6 6 4.5 8.6 4.5c1.5 0 2.7.8 3.4 1.9.7-1.1 1.9-1.9 3.4-1.9 2.6 0 5.1 2.1 5.1 5.3C20.5 15.7 12 21 12 21z',
  power: 'M14.5 2l-1.8 7.2 5.8-.7L9.5 22l1.8-8.3-5.8.8z',
  sword: 'M19.5 2.5L21.5 4.5 10 16l-1.5 1.5 1.5 1.5-1.5 1.5-2-2-2.5 2.5-1.5-1.5L5 17l-2-2 1.5-1.5L6 15l1.5-1.5z',
  lock: 'M6 10V7.5a6 6 0 0112 0V10h1.5v12h-15V10zm3 0h6V7.5a3 3 0 00-6 0z',
  clock: 'M12 2a10 10 0 110 20 10 10 0 010-20zm-1.2 4v7l5.6 3.3 1.1-1.8-4.3-2.6V6z',
  chest: 'M3 9a5 5 0 015-5h8a5 5 0 015 5v1H3zm0 3h7v2h4v-2h7v8H3z',
  star: 'M12 2.5l2.9 6.1 6.6.8-4.9 4.6 1.3 6.6L12 17.3l-5.9 3.3 1.3-6.6-4.9-4.6 6.6-.8z',
  bag: 'M8 7V6a4 4 0 018 0v1h3.5l1 15h-17l1-15zm2 0h4V6a2 2 0 00-4 0z',
  tree: 'M12 2l5 6h-3l4 5h-3l4 5H13v4h-2v-4H5l4-5H6l4-5H7z',
  info: 'M12 2a10 10 0 110 20 10 10 0 010-20zm-1.3 8v8h2.6v-8zm1.3-4.3a1.6 1.6 0 100 3.2 1.6 1.6 0 000-3.2z',
};

export type GlyphName = keyof typeof PATHS;

export function glyph(name: GlyphName, cls = ''): SVGSVGElement {
  const ns = 'http://www.w3.org/2000/svg';
  const svg = document.createElementNS(ns, 'svg');
  svg.setAttribute('viewBox', '0 0 24 24');
  svg.setAttribute('aria-hidden', 'true');
  svg.setAttribute('class', `glyph ${cls}`.trim());
  const path = document.createElementNS(ns, 'path');
  path.setAttribute('d', PATHS[name]!);
  path.setAttribute('fill-rule', 'evenodd');
  svg.append(path);
  return svg;
}

/** Symbol + wartość w jednej „pastylce”, np. korona 4:00. */
export function glyphChip(name: GlyphName, value: string, cls = ''): HTMLSpanElement {
  const chip = document.createElement('span');
  chip.className = `gchip ${cls}`.trim();
  chip.append(glyph(name), document.createTextNode(value));
  return chip;
}
